import { AbstractControl, ValidationErrors } from '@angular/forms';

const PHONE_PATTERN = /(?:\(\+?\d+\)|\+?\d+)(?:\s*[\-\/]*\s*\d+)+/;

export function phone(control: AbstractControl): ValidationErrors | null {
  // only validate if user has already input some text
  const hasError = control.value && !PHONE_PATTERN.test(control.value);
  return hasError ? {phone: true} : null;
}


